module.exports = __webpack_public_path__ + "static/media/logo.451bcf93.png";


//////////////////
// WEBPACK FOOTER
// ./src/files/logo.png
// module id = 312
// module chunks = 0